var _path, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinIncorrect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 24.7917H14.5833V32.0833L11.6667 35V24.7917ZM14.5833 8.02083C14.5833 4.63896 16.361 1.67708 19.0269 0H5.83333C5.9325 2.78688 9.37562 3.05812 9.37562 7.29167C9.37562 12.791 4.375 12.091 4.375 21.875H21.875C21.875 19.8946 21.6635 18.3575 21.3369 17.0975C17.4315 15.9265 14.5833 12.3083 14.5833 8.02083ZM30.625 8.02083C30.625 11.6448 27.6835 14.5833 24.0625 14.5833C20.4415 14.5833 17.5 11.6448 17.5 8.02083C17.5 4.39688 20.4415 1.45833 24.0625 1.45833C27.6835 1.45833 30.625 4.39688 30.625 8.02083ZM26.1246 4.92625L24.0625 6.98833L22.0004 4.92625L20.9694 5.95875L23.0315 8.02083L20.9694 10.0829L22.0004 11.1154L24.0625 9.05187L26.1246 11.114L27.1571 10.0815L25.095 8.02083L27.1571 5.95875L26.1246 4.92625V4.92625Z",
    fill: "#5A6474"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 1.45833,
    width: 13.125,
    height: 13.125,
    rx: 6.5625,
    fill: "#E15847"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0116,
    y: 11.1067,
    width: 1.45711,
    height: 7.25901,
    transform: "rotate(-135.003 22.0116 11.1067)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.1443,
    y: 10.0763,
    width: 1.45711,
    height: 7.25901,
    transform: "rotate(135 27.1443 10.0763)",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIncorrect);
export default __webpack_public_path__ + "static/media/pin-incorrect.b093211ab8d38d1990eb1085218c4c16.svg";
export { ForwardRef as ReactComponent };